<template>
    <div class="partners">
        <div class="text-center text-primary py-7" v-if="dataLoading">
            <loading-animation class="fs-10"/>
            <p>Please wait while data is being loaded...</p>
        </div>
        <div v-else>
<!--            <certificate :banner="banner"></certificate>-->
            <solution-agencies :details="solution_details"></solution-agencies>
            <agencies :details="details"></agencies>
        </div>
    </div>
</template>

<script>
// import certificate from '../components/Partners/certificate';
import Agencies from '../components/Partners/partners/agencies';
import SolutionAgencies from '../components/Partners/partners/solutionAgencies';
import axios from 'secure-axios';
import urls from '../data/urls';

export default {
    name: 'Partners',
    // components: { Agencies, certificate },
    components: { Agencies, SolutionAgencies },
    data () {
        return {
            dataLoading: false,
            details: null,
            solution_details: null,
            banner: null
        };
    },
    mounted () {
        this.loadPartnerData();
        this.loadSolutionPartnerData();
    },
    methods: {
        async loadPartnerData () {
            this.dataLoading = true;
            const response = await axios.get(urls.partner.partnersPage);
            const json = response.data;
            if (json.error === false) {
                this.details = json.data;
                if (json.partner_banner.length !== 0) {
                    this.banner = json.partner_banner[0].image;
                }
                this.dataLoading = false;
            } else {
                this.$notify('Could not load partner data, Please try again later', 'Error', {
                    type: 'danger'
                });
            }
            this.dataLoading = false;
        },
        async loadSolutionPartnerData () {
            this.dataLoading = true;
            const response = await axios.get(urls.partner.solutionPartnersPage);
            const json = response.data;
            if (json.error === false) {
                this.solution_details = json.data;
                this.dataLoading = false;
            } else {
                this.$notify('Could not load solution partner data, Please try again later', 'Error', {
                    type: 'danger'
                });
            }
            this.dataLoading = false;
        }
    }
};
</script>

<style scoped>
.partners {
    background-color: #FFFFFF;
}

</style>
